module.exports = __webpack_public_path__ + "img/confirmation.db7c69c1.svg";